<template>
  <button
    class="next-button pill-button-lg"
    :disabled="disabled"
    @click="$emit('click')"
    :style="buttonStyles"
  >
    <span>{{ label }}</span>
    <svg
      viewBox="0 0 385 385"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>chevron-right-solid</title>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="chevron-right-solid"
          transform="translate(0.874063, 0.874062)"
          fill="#626262"
          :style="{ fill: textColor }"
          fill-rule="nonzero"
        >
          <g
            id="Group"
            :style="{ fill: textColor }"
            transform="translate(191.625937, 191.625937) scale(-1, 1) rotate(-45.000000) translate(-191.625937, -191.625937) translate(56.125938, 56.125937)"
          >
            <rect
              id="Rectangle"
              x="1.9905464"
              y="0"
              width="269.009453"
              height="82.7721393"
              rx="41.2015297"
            ></rect>
            <path
              d="M-51.9171271,95.1092042 L134.689266,95.1092042 C157.444243,95.1092042 175.890796,113.555757 175.890796,136.310734 L175.890796,136.679814 C175.890796,159.43479 157.444243,177.881343 134.689266,177.881343 L-51.9171271,177.881343 C-74.6721037,177.881343 -93.1186569,159.43479 -93.1186569,136.679814 L-93.1186569,136.310734 C-93.1186569,113.555757 -74.6721037,95.1092042 -51.9171271,95.1092042 Z"
              id="Rectangle"
              transform="translate(41.386069, 136.495274) rotate(90.000000) translate(-41.386069, -136.495274) "
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'NextButton',
  props: {
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    buttonStyles() {
      const styles = {}
      if (this.backgroundColor) {
        styles['background-color'] = this.backgroundColor
      }
      if (this.textColor) {
        styles.color = this.textColor
      }
      return styles
    }
  }
}
</script>

<style lang="scss" scoped>
.next-button {
  box-shadow: var(--default-shadow);
  background-color: var(--arch-color);
  color: var(--arch-text-color);

  svg {
    width: 13px;
    height: 13px;
    margin-left: 8px;
  }

  :deep(g) {
    fill: var(--arch-text-color);
  }

  &:disabled {
    opacity: 1;
    background: #f9f9f9 !important;
    box-shadow: none;
    color: #a7a7a7 !important;
    :deep(g) {
      fill: #a7a7a7 !important;
    }
  }
}
</style>
